/**
 * Unified activity indicator / loader design across the app.
 * Use these constants for SpinnerDotted and other spinners so all loaders look consistent.
 */
export const LOADER_COLOR = '#CD47F3';
export const LOADER_SIZE = 48;
export const LOADER_SIZE_SMALL = 36;
